export type ResultType = "Success" | "Failure" | "ExpectedFailure";

/**
 * A set of error codes to determine whether an encountered error should be treated as expected.
 */
export const expected_error_codes = new Set([
  "GeoLocInvalidRequest",
  "ItemDoesNotExist",
  "activityLimitReached",
  "extensionError",
  "invalidRange",
  "itemNotFound",
  "malwareDetected",
  "nameAlreadyExists",
  "notAllowed",
  "quotaLimitReached",
  "resourceModified",
  "resyncRequired",
  "syncStateNotFound",
  "unauthenticated",
  "ownerCannotShareWithSelf"
]);

const expected_error_messages = new Set([
  "The user aborted a request.",
  "<safe>The user aborted a request.</safe>",
  "The operation was aborted. ",
  "<safe>The operation was aborted. </safe>",
  "Fetch is aborted",
  "<safe>Fetch is aborted</safe>",
  "Failed to fetch",
  "<safe>Failed to fetch</safe>",
  "NetworkError when attempting to fetch resource.",
  "<safe>NetworkError when attempting to fetch resource.</safe>",
  "The Internet connection appears to be offline.",
  "<safe>The Internet connection appears to be offline.</safe>",
  "Connection reset by peer",
  "<safe>Connection reset by peer</safe>",
  '{"status":-1,"code":"NoConnection"}',
  '<safe>{"status":-1,"code":"NoConnection"}</safe>',
  "Timeout",
  "<safe>Timeout</safe>",
  "Load failed",
  "User migrated.",
  "The Permission and password is not matched.",
  "The sharing link no longer exists, or you do not have permission to access it."
]);

/**
 * Used to determine if the failure is an expected failure or not.
 *
 * @param code The error code returned from the network
 * @param message An optional message that may indicdate failure details.
 * @returns ExpectedFailure when it matches a well-know and expected condition.
 */
export function getFailureType(code: string, message?: string): ResultType {
  if (expected_error_codes.has(code) || (message && (expected_error_messages.has(message) || message.includes("Network issue")))) {
    return "ExpectedFailure";
  }

  return "Failure";
}
